module.exports = __webpack_public_path__ + "static/media/task_link.c677ba0a.svg";